import OrgIdList from '../data/OrgIdName.json';

export const generateRandomNumber = (min, max) => {
  const rand = Math.floor(Math.random() * Math.floor(max));
  return rand;
};

export const  getOrgId = (orgName) => {
  let orgId = "";
  OrgIdList.OrgMapping.map(item => {
    if(item.orgName === orgName){
      orgId =  item.orgId;
    }
  });
  return orgId;
}

export const randomPaddedIntString =  (min, max, padString, length) =>
{
  var str = Math.floor(Math.random() * (max - min + 1) + min);

  while (str.length < length)
  {
    str = padString + str;
  }
  return str;
}

export const timer = (counter) => {
  let mins =  Math.floor(counter / 60);
  let secs = counter - mins*60 ;
  if(mins < 10) {
    mins = '0' + mins;
  }
  if(secs < 10) {
    secs = '0' + secs;
  }
  return mins + ':' + secs;
}